module.exports = __webpack_public_path__ + "static/media/libro11.ba6f7823.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro11.png
// module id = 359
// module chunks = 0